import { keyframes } from '@mui/system';
import { makeStyles } from '@/styles/v4/tss-react';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const useStyles = makeStyles({ name: 'PriceOfPowerFormContent' })(
  ({ palette, spacing, breakpoints, typography }) => ({
    subtitle: {
      color: palette.semantic.text.secondary,
    },
    form: {
      width: '100%',
    },
    addressSpinnerIcon: {
      display: 'block',
      animation: `${spin} 0.8s linear infinite`,
      '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
      },
    },
    rowField: {
      flex: '1 1 0',
      minWidth: 0,
    },
    utilitySlot: {
      minWidth: 0,
      overflow: 'hidden',
      flexBasis: 0,
      flexShrink: 1,
    },
    submit: {
      flexShrink: 0,
    },
    labeledFields: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      gap: spacing(0),
      width: '100%',
      // The shared Dropdown label uses a fixed 14px; match the text field label so the row lines up.
      '& label': { ...typography.bodyMd },
    },
    addressSlot: {
      flexBasis: '100%',
      minWidth: 0,

      [breakpoints.up('md')]: {
        flexBasis: 0,
      },
    },
    labeledSubmit: {
      width: '100%',
      marginTop: spacing(1),
    },
    submitError: {
      '& p': {
        marginTop: 0,
        textAlign: 'left',
      },
    },
  })
);
